import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    partyIdentifierCode: Yup.string(),
    partyIdentifierNumber: Yup.string().matches("^[a-zA-Z0-9]*$","Enter alphanumeric characters.").nullable().when('partyIdentifierCode', {
      is: partyIdentifierCode => partyIdentifierCode && partyIdentifierCode.length>0,
      then: Yup.string().required("Required"),
      othewise:Yup.string().nullable()
    })
  })
} 

export default makeValidationSchema
